import axios from 'axios'
import Cookies from 'js-cookie'

const ipUrl = '/frontier/ip/raw'

let cachedIp
let pendingPromise = false

export default async function getIp(ignoreCache) {
  if (ignoreCache) {
    cachedIp = undefined
    pendingPromise = false
  }

  if (cachedIp) {
    return cachedIp
  }

  const ipCookie = getIpFromSnowCookie()
  if (ipCookie) {
    cachedIp = ipCookie
    return ipCookie
  }

  // if the fsgeo cookie wasn't set, then fallback to the /frontier/ip/raw endpoint
  pendingPromise = pendingPromise || axios.get(ipUrl, { fsUserAgentChainSuffix: 'zion-session' })

  try {
    const { data } = await pendingPromise

    if (!data.ip) {
      throw new Error('error finding ip')
    }

    cachedIp = data.ip
    return data.ip
  } finally {
    pendingPromise = false
  }
}

function getIpFromSnowCookie() {
  // geolocation.js middleware in snow sets the fsgeo cookie to the ip address
  return Cookies.get('fsgeo')
}

// just a helper function for unit tests
export function resetCachedIp() {
  cachedIp = false
  pendingPromise = false
}
